import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunk from 'redux-thunk'
import rootReducer from './reducers'

const initialState = {}

// const actionLogger = store => next => action => {
//   console.log('Dispatching action:', action.type, 'with payload:', action.payload, 'at', new Date().toISOString());
//   return next(action);
// };

const middleware = [thunk]

const store = createStore(
  rootReducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
)

export default store
